import { api, usePrefetchNow } from '../api'

const stripeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getStripePublishableKey: builder.query<string, void>({
      query: () => ({
        url: `/token/stripePublishableKey`,
        responseHandler: 'text',
      }),
    }),
  }),
})

export const {
  endpoints: { getStripePublishableKey },
  useGetStripePublishableKeyQuery,
} = stripeApi

export const usePrefetchStripePubKey = () => usePrefetchNow(getStripePublishableKey, null)
